export function formatEntityTypeLabel(entityType: string, count: number): string {
  const singular = entityType.replace(/_/g, ' ');
  if (count === 1) return singular;
  return pluralize(singular);
}

function pluralize(singular: string): string {
  const parts = singular.split(' ');
  const last = parts[parts.length - 1];
  parts[parts.length - 1] = pluralizeWord(last);
  return parts.join(' ');
}

function pluralizeWord(word: string): string {
  if (/(s|x|z|ch|sh)$/i.test(word)) return `${word}es`;
  if (/[^aeiou]y$/i.test(word)) return `${word.slice(0, -1)}ies`;
  return `${word}s`;
}
